module.exports = require("./lib/_stream_passthrough.js")



/*****************
 ** WEBPACK FOOTER
 ** ./~/stream-browserify/~/readable-stream/passthrough.js
 ** module id = 55
 ** module chunks = 0
 **/